import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  IconConfig,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { UiModule } from 'src/app/ui/ui.module';

@Component({
  selector: 'app-badged-avatar-or-icon',
  standalone: true,
  imports: [CommonModule, PencilIconComponent, UiModule],
  templateUrl: './badged-avatar-or-icon.component.html',
  styleUrls: ['./badged-avatar-or-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgedAvatarOrIconComponent {
  @Input() showAvatar = true;
  @Input() showBadge = false;
  @Input() iconConfig?: IconConfig;
  @Input() avatarWidth?: number;
  @Input() isUser = false;
  @Input() profileImage?: string;
  @Input() userRole?: string;
  @Input() userEmail?: string;
  @Input() userName?: string;
}
